import React, { useEffect, useState } from 'react'
import { getGoodTypesAllAPI } from '../../../api/products/goodTypeAPI'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getGoodsAllAPI } from '../../../api/products/goodAPI'
import MySpiner from '../../UI/spiner/MySpiner'
import { getFactoriesAllAPI } from '../../../api/factory/factoryAPI'
import { getDepartmentsAllAPI } from '../../../api/department/departmentAPI'
import { departmentText } from '../../../helpers/department/DepartmentHelper'

// setValueObjectForm - необовʼязковий. Віддає нагору весь обʼєкт обраного підрозділу,
// а не лише його id (потрібно, наприклад, щоб знати прапорець isDescriptionRequired)
const DepartmentSelectMain = ({ 
	departmentTypeId, required, setValidate, setValueForm, forciblyValue, optionDefault, withoutType = false,
	setValueObjectForm
}) => {

  	const [value, setValue] = useState(forciblyValue)
	const [departments, setDepartments] = useState([])
	// const [options, setOptions] = useState([])

	// console.log('forciblyValue', forciblyValue)
	// console.log('departmentTypeId', departmentTypeId)

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		setValueFirst()
	}, [forciblyValue])

	useEffect(() => {
		if (departmentTypeId) {
			getDepartments()
		} else if (withoutType === true) {
			getDepartments()
		}
	}, [departmentTypeId])

	// useEffect(() => {
	// 	setDepartmentOptions()
	// }, [departments])

	useEffect(() => {
		valid()
	}, [required, value])

	const getDepartments = () => {
		setValueForm(null)
		if (setValueObjectForm) {
			setValueObjectForm(null)
		}
		setValue('')
		setLoading(true)
		getDepartmentsAllAPI({ departmentTypeId }).then(data => {
			setDepartments(data)
			setLoading(false)
		}).catch(e => {
			// setError(responseError(e))
			setLoading(false)
			console.error(responseError(e))
		})
	}

	const setValueFirst = () => {
		if (!value && forciblyValue) {
			if (forciblyValue.type && forciblyValue.id) {
				setValue({
					id: forciblyValue.id,
					type: forciblyValue.type	
				})
			}		
		}
	}

	// const setDepartmentOptions = () => {
	// 	if (departments && departments.length > 0) {
	// 		const temp = []

	// 		for (const department of departments) {
	// 			temp.push({
	// 				id: department.type + '-' + department.id,
	// 				name: departmentText[department.type] + ' - ' + department.name
	// 			})
	// 		}

	// 		setOptions(temp)
	// 	} else {
	// 		setOptions([])
	// 	}
	// }

	// const changeValue = (id) => { // Обновление периода при изменении в селекте
    //     if (departments && departments.length > 0) {
    //         let temp = {}

    //         departments.some(department => {
    //             const idTemp = department.type + '-' + department.id
    //             if (idTemp === id) {
    //                 temp = {
    //                     id: department.id,
    //                     type: department.type
    //                 }
    //                 return true
    //             }
    //         })

	// 		setValueForm(temp)
	// 		setValue(id)
    //     }
    // }

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
	<>
		{
			loading ?
				<MySpiner />
			:
				<MySelect
					value={value}
					label="Підрозділ"
					labelId="select__department-label"
					id='select__department'
					onChange = {e => {
						// changeValue(e)
						setValueForm(e)
						setValue(e)
						if (setValueObjectForm) {
							const departmentSelected = departments.find(department => department.id == e)
							setValueObjectForm(departmentSelected ? departmentSelected : null)
						}
					}}
					nameField='Підрозділ'
					// sx={{width: '200px'}}
					optionDefault={optionDefault ? optionDefault : ''}
					options={
						// options && options.length > 0 ? 
						// 	options.map(department => {
						// 		return {id: department.id, name: department.name}
						// 	})
						// : []	
						departments && departments.length > 0 ? 
							departments.map(department => {
								return {id: department.id, name: department.name}
							})
						: []	
					}
					disabled={departmentTypeId || withoutType === true ? false : true}
					// options={[]}
				/>
		}
	</>
  )
}

export default DepartmentSelectMain